import PropTypes from 'prop-types';

import useStyles from './useStyles';

const propTypes = {
  classes: PropTypes.shape(),
};

const defaultProps = {
  classes: null,
};

const KeyEnter = ({ classes, ...restProps }) => {
  const styles = useStyles({ classes });

  return (
    <span
      className={styles.root}
      {...restProps}
    >
      Enter&nbsp;⏎
    </span>
  );
};

KeyEnter.propTypes = propTypes;
KeyEnter.defaultProps = defaultProps;

export default KeyEnter;
